<template>
<div class="fixed-top" id="header" >
  <b-navbar toggleable="lg" variant="" type=""  >
    <b-row>
      <b-col cols="11">
          <b-navbar-brand>
            <table>
              <tbody>
                <tr>
                    <td rowspan="5" style="width:100px">  <b-img class="logo" src="../assets/apdcl_logo.png" fluid  alt="Responsive image"></b-img></td>

                </tr>
                  <tr>
                    <td id="title-a" class="title-a text-blue ">অসম শক্তি বিতৰণ কোম্পানী লিমিটেড</td>
                      <!-- <td  class="text-blue right" style="text-align: right;width: 45vw;">Welcome, <data id="consName">Asim Pathak </data></td> -->
                  </tr>
                  <tr>
                    <td id="title-e" class="title-e text-blue">ASSAM POWER DISTRIBUTION COMPANY LIMITED</td>
                    <!-- <td style="text-align: right;width: 45vw;">
                      <router-link to="#">
                        <b-button @click="$bvModal.show('logoutModal')" variant="outline-danger" size="sm">Log Out</b-button>
                      </router-link>
                    </td> -->
                  </tr>
              </tbody>
            </table>
          </b-navbar-brand>
        </b-col>
        <b-col cols="1" style="margin-left: -30px;">
          <b-navbar-toggle target="nav-collapse" style="border:none; outline: none;">
            <template>
              <div style="border:solid 1px black;border-radius:3px;font-size: 2rem;">
              <b-icon icon="list"  ></b-icon>
            </div>
            </template>
          </b-navbar-toggle>
        </b-col>
      </b-row>
      <b-collapse id="nav-collapse" is-nav class="nav-bgcolor responsiveNavbar" style="">
        <b-navbar-nav class="ml-auto">
          <b-row>
            <b-col cols="9" class="marginLeft text-blue right" style="text-align: right;width: 45vw;"> <data id="consNameMb"> </data></b-col>
            <b-col cols="3" style="text-align: right;width: 45vw;">
              <router-link to="#">
              <b-button @click="$bvModal.show('logoutModalMb')" variant="outline-danger" size="sm">Log Out</b-button>
              </router-link>
            </b-col>
          </b-row>
        </b-navbar-nav>
      </b-collapse>
</b-navbar>
<span id="tagline-a" hidden ></span>
<span id="tagline-e" hidden></span>
<span id="language" hidden ></span>
<span id="support" hidden></span>

<b-modal id="logoutModalMb" centered  scrollable title="Confirm Log Out" hide-footer>
    <p class="success">
      Are you sure you want to Log Out?<br><br>
      <b-button id="" @click="logout()"  size="sm" variant="outline-success"  style="width:100px">Yes</b-button>&nbsp&nbsp&nbsp&nbsp
      <b-button id="" @click="closeModal('logoutModalMb')" size="sm" variant="outline-primary" style="width:100px">No </b-button>
    </p>
</b-modal>

</div>


</template>
<script type="text/javascript">
import axios from 'axios'
export default {
    methods:
    {
      logout()
        {
          var  accessToken = sessionStorage.getItem("accessToken");
        let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: this.$urlMyBijulee+'/auth/logout',
        headers: { 
          'Authorization': accessToken, 
          'Content-Type': 'application/json'
        },
      
      };
      
      this.show=true;
      var parent = this;
      axios.request(config)
      .then((response) => {
        parent.show= false;
       if(response.data.status=="success")
       {
        sessionStorage.removeItem("accessToken");
        sessionStorage.removeItem("consList");
        sessionStorage.removeItem("selectedCons");
         window.location.href="/website"
       }
       else{
        parent.$bvToast.toast('Error in Log Out !', {
        title: `Alert`,
        variant: 'danger',
        solid: true
      })
       }
      })
          },
        closeModal(id)
        {
          this.$bvModal.hide(id)
        }
    }
  }
</script>
<style lang="scss" scoped="true" >

body
{
  overflow-x: hidden;
}
#header
{
  transition: 0.6s;
  background-color: #ffff;
  box-shadow: 0 4px 7px 1px #e0e0e0;
}

@media (max-width: 576px) {
  .title-a
  {
    // font-size: 1.3rem;
    font-size: 11.5px;
    font-weight: 900;
    margin-top: 0px;
    letter-spacing: 0.5px;

  }
  .title-e
  {
    // font-size: 1.3rem;
    font-size: 11.5px;
    font-weight: 700;
    letter-spacing: 0.5px;

  }
  .logo{
    height:35px;
    width:35px;
    margin-right:0px;
  }

 }

 /* Medium devices (tablets, 768px and up) */
 @media (max-width: 768px) and (min-width: 577px) {
   .title-a
   {
     // font-size: 1.3rem;
     font-size: 18px;
     font-weight: 900;
     margin-top: 0px;
     letter-spacing: 0.5px;

   }
   .title-e
   {
     // font-size: 1.3rem;
     font-size: 18px;
     font-weight: 700;
     letter-spacing: 0.5px;

   }
   .logo{
     height:50px;
     width:50px;
     margin-right:0px;
   }

 }

// .title-a
// {
//   font-size: 1.3rem;
//   font-weight: 900;
//   margin-top: 0px;
//   letter-spacing: 0.5px;
//
// }
// .title-e
// {
//   font-size: 1.3rem;
//   font-weight: 700;
//   letter-spacing: 0.5px;
//
// }
@font-face {
  font-family: Assamese_Font;
  src: url("../assets/Assamese_font/KirtanUni.ttf");
}
div{
    font-family: arial, Assamese_Font;
}

</style>
